import React, { memo, type ReactElement } from 'react';
import { Box, TabContent } from '@saviynt/design-system';
import cx from 'classnames';

import SodSidePanelHistory from '../../../../shared/components/SodSidePanelHistory';
import { VIOLATIONS_LIST_SIDEPANEL_TABS } from '../../../../shared/constants';
import { type ViolationsTabSidePanelRowContextState } from '../../data-layer/violationsTabTypes';

interface ViolationsSidePanelSummaryProps {
  currentRowContext: ViolationsTabSidePanelRowContextState;
  activeTab: string;
}

/**
 * ViolationsSidePanelHistory
 */
function ViolationsSidePanelHistory({
  currentRowContext,
  activeTab,
}: ViolationsSidePanelSummaryProps): ReactElement {
  const historyTabClasses = cx(
    'Sod-ViolationsSidePanelBody-tabContent',
    'Sod-ViolationsSidePanelBody-tabContent--isHistoryTab'
  );

  return (
    <TabContent
      className={historyTabClasses}
      value={activeTab}
      tabValue={VIOLATIONS_LIST_SIDEPANEL_TABS.TAB_HISTORY}>
      <Box className='Sod-ViolationsSidePanelBody-tabContentWrapper Sod-ViolationsSidePanelBody-tabContentWrapper--isHistoryTab'>
        <SodSidePanelHistory
          sodKey={currentRowContext.id}
          isInDetailsPage={false}
        />
      </Box>
    </TabContent>
  );
}

export default memo(ViolationsSidePanelHistory);
